import "./minting.scss"

export default function Minting() {
    return (
        <div className = "minting" id="mynok">
            <div className="mintingContent">
                <div className="mintingLeft">
                    <div className="leftContent">
                        <div className="appStore">
                            <a href="https://www.apple.com/app-store"><img src="assets/app-play.png" alt="" /></a>
                        </div>
                        <div className="googlePlay">
                            <a href="https://store.google.com"><img src="assets/google-play.png" alt="" /></a>
                        </div>
                        <div className="windowStore">
                            <a href="https://www.microsoft.com/en-us/store/apps/windows"><img src="assets/windows-play.png" alt="" /></a>
                        </div>

                    </div>
                </div>
                <div className="mintingRight">
                    <div className="rightContent">
                        <div className="aboutMintingTitle">
                            <h1>NOK MINTING</h1>
                        </div>
                        <div className="aboutMintingDesc">
                            <p>
                            You can be one of the few people to get in on the next NFT ART trend. The NOK collection is a limited edition that is secured and verifiable on the blockchain. Holding NOK NFT will grant you access to NOK games, NOK markets and NOK finance platforms.
                            </p>
                        </div>
                        <button className = "learnMoreButton">LEARN MORE</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
